import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import emails from '../../arrays/emails.json'
import axios from 'axios';
import Pagination from '../Paginations';
import { getUserReleases } from '../../api/releases';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createInviteSplit, createSplit, getAllUserSplits, updateSplit } from '../../api/splits';
import { getAllUsers } from '../../api/user';
import { uri } from '../../constants';

// Import tab components
import MySplitsTab from './SplitTabs/MySplitsTab';
import AvailableTracksTab from './SplitTabs/AvailableTracksTab';
import InviteSplitsTab from './SplitTabs/InviteSplitsTab';
import SplitModal from './SplitTabs/SplitModal';

const Splits = () => {

    const uid = localStorage.getItem('uid')
    const [tracks, setTracks] = useState([])
    const [filteredTracks, setFilteredTracks] = useState([])
    const [mySplits, setMySplits] = useState([])
    const [splits, setSplits] = useState([])
    const [inviteSplits, setInviteSplits] = useState([])
    const [tab, setTab] = useState(1)
    const [email, setEmail] = useState('')
    const [isrc, setIsrc] = useState('')
    const [title, setTitle] = useState('')

    const closeRef = useRef()
    const successCloseRef = useRef()
    const queryClient = useQueryClient()
    const { data: releases, isLoading, error: releaseError } = useQuery({
        queryKey: ["releases", uid],
        queryFn: async () => await getUserReleases(uid),
        select: (data) => data.data
    })
    const {data: allUsers, isLoading: userLoading, error:userError} = useQuery({
        queryKey: ["users"],
        queryFn: async ()=> await getAllUsers(),
    })
    const { data: allSplits, isLoading: splitsLoading, error: splitsError } = useQuery({
        queryKey: ["all_splits", uid],
        queryFn: async () => await getAllUserSplits(uid)
    })
   
    useEffect(() => {
        if (releases && allSplits) {
            console.log(releases, "releases")
            const liveReleases = releases?.releases.filter(item => item.status?.toLowerCase() === 'distributed')
            const flatTracks = liveReleases?.flatMap((release) => release.tracks)
        
            if (allSplits.splits.length > 0) {
                setTracks(flatTracks.filter(track => allSplits.splits.find(split => split.isrc === track.isrc) == undefined))
                setFilteredTracks(flatTracks.filter(track => allSplits.splits.find(split => split.isrc === track.isrc) == undefined))
                setSplits(allSplits.splits)
                console.log(allSplits.splits, "all splits")
                const flattened = allSplits.splits.map(item => ({...item.track, ...item}))
                setMySplits(flattened)
            } else {
                console.log(liveReleases, "live release")
                setTracks(flatTracks)
                setFilteredTracks(flatTracks)
            }
            if(allSplits.inviteSplits?.length > 0){
                setInviteSplits(allSplits.inviteSplits.filter(item => item.email != email));
            }
            
        }
    }, [releases, allSplits])

    /////////// PAGINATION ///////////
    const itemsPerPage = 25;
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    
    // Create a unique list of tracks based on ISRC
    const uniqueTracks = [];
    const trackIsrcs = new Set();
    
    mySplits.forEach(split => {
        const isrc = split.isrc || (split.track && split.track.isrc);
        if (isrc && !trackIsrcs.has(isrc)) {
            trackIsrcs.add(isrc);
            uniqueTracks.push({
                title: split.title,
                isrc: isrc,
                genre: split.genre || (split.track && split.track.genre) || '',
            });
        }
    });
    
    const currentItems = tab === 2 
        ? filteredTracks.slice(indexOfFirstItem, indexOfLastItem) 
        : uniqueTracks.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = tab === 2 
        ? Math.ceil(filteredTracks.length / itemsPerPage) 
        : Math.ceil(uniqueTracks.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    //////// INVITE PAGINATION ////////
    const [inviteCurrentPage, setInviteCurrentPage] = useState(1);

    const inviteIndexOfLastItem = currentPage * itemsPerPage;
    const inviteIndexOfFirstItem = inviteIndexOfLastItem - itemsPerPage;
    const inviteCurrentItems = inviteSplits.slice(inviteIndexOfFirstItem, inviteIndexOfLastItem)

    const inviteTotalPages = Math.ceil(inviteSplits.length / itemsPerPage)

    const handleInvitePageChange = (pageNumber) => {
        setInviteCurrentPage(pageNumber);
    };


    ///////// SEARCH /////////
    const handleSearch = (event) => {
        const term = event.target.value;

        setCurrentPage(1)

        const filteredResults = tracks.filter((track) => {
            const { title, isrc } = track;
            const lowerCaseTerm = term.toLowerCase();

            // Check if the item's properties contain the search term
            return (
                title.toLowerCase().includes(lowerCaseTerm) ||
                isrc.toLowerCase().includes(lowerCaseTerm)
            );
        });

        setFilteredTracks(filteredResults);
    };

    const [error, setError] = useState('')
    const [collaborator, setCollaborator] = useState('')
    const [percentage, setPercentage] = useState(0)
    const [emailExists, setEmailExists] = useState(true);
    const [inviteMode, setInviteMode] = useState(false);
    const [pendingInviteEmail, setPendingInviteEmail] = useState('');
    const [pendingInvitePercentage, setPendingInvitePercentage] = useState(0);
    const inviteModalRef = useRef();

    // Handle collaborator input change - check if email exists
    const handleCollaboratorInputChange = (e) => {
        const inputValue = e.target.value;
        setCollaborator(inputValue);
        
        // Check if this is a valid email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmailFormat = emailRegex.test(inputValue);
        
        if (isValidEmailFormat) {
            // Check if email exists in our system
            const exists = allUsers?.some(user => 
                user.email?.toLowerCase() === inputValue.toLowerCase()
            );
            setInviteMode(!exists);
        } else {
            setInviteMode(false);
        }
    };
    
    const handleError = (errorMsg) => {
        setError(errorMsg)
        setTimeout(() => {
            setError('')
        }, 3000);
    }


    ///// EMAILS /////
    const sendEmails = async (email, percentage) => {
        const emailTemplate = emails[4]
        const subject = emailTemplate.subject
        const content = emailTemplate.content.replace(/\*\|track_title\|\*/g, title)
        try {

            const userExist = allUsers.find(user => user.email === email)

            if (userExist) {
                await createInviteSplit({
                    user_id: userExist.user_id,
                    revenue_share: 0,
                    isrc: isrc,
                    is_recoupment: false,
                    percentage: percentage,
                    title: title,
                })
            } else {
                const response = await axios.post(`${uri}/email`, {
                    email: email,
                    subject,
                    content
                })
                return response.data;
            }

        } catch (error) {
            return null;
        }
    };


    const successBtn = useRef()
    const [saveText, setSaveText] = useState('Save')
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [newSplits, setNewSplits] = useState([])
    const [recoup, setRecoup] = useState(0);
    const [recoupEmail, setRecoupEmail] = useState('');

    // Calculate total shares
    const calculateTotalShares = () => {
        let total = 0;
        if (splits?.length > 0) {
            splits.forEach(split => {
                total += split.percentage * 1;
            });
        }
        return total;
    }


    // Modified addCollaborator function to handle non-existing users
    const addCollaborator = () => {
        if (collaborator.trim() === '') {
            handleError('Please enter collaborator email');
            return;
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(collaborator)) {
            handleError('Please enter a valid email address');
            return;
        }

        if (percentage <= 0) {
            handleError('Percentage must be greater than 0');
            return;
        }

        const totalShares = calculateTotalShares();
        if (totalShares + percentage * 1 > 100) {
            handleError('Shares sum cannot exceed 100');
            return;
        }

        // Check if user is already added
        if (splits?.some(split => split.user?.toLowerCase() === collaborator.toLowerCase())) {
            handleError('This collaborator is already added');
            return;
        }

        // Check if user exists in the system
        const userExists = allUsers?.some(user => 
            user.email?.toLowerCase() === collaborator.toLowerCase()
        );

        if (!userExists) {
            // Store pending invite details and show confirmation modal
            setPendingInviteEmail(collaborator);
            setPendingInvitePercentage(percentage);
            // Open the invite confirmation modal
            const inviteModal = new bootstrap.Modal(document.getElementById('inviteConfirmModal'));
            inviteModal.show();
        } else {
            // User exists, proceed normally
            const userID = allUsers?.find(user => 
                user.email?.toLowerCase() === collaborator.toLowerCase()
            )?.user_id;
            
            addSplitToState(userID, collaborator, percentage);
        }
    };

    // Helper function to add split to state
    const addSplitToState = (userID, email, sharePercentage) => {
        const newSplit = {
            user_id: userID || null, // null for invited users
            user: email,
            recoupment: 0,
            percentage: sharePercentage,
            track: isrc,
            title: title,
            isInvited: !userID // Flag to indicate this is an invited user
        };
        setNewSplits([...newSplits, newSplit]);
        setCollaborator('');
        setPercentage(0);
    };

    // Function to confirm adding a non-existing user
    const confirmAddInvitedUser = async () => {
        try {
            // Add the user to splits with null user_id
            addSplitToState(null, pendingInviteEmail, pendingInvitePercentage);
            
            // Send invite email
            await sendEmails(pendingInviteEmail, pendingInvitePercentage);
            
            // Close the modal
            const modal = bootstrap.Modal.getInstance(document.getElementById('inviteConfirmModal'));
            modal.hide();
            
            // Reset pending invite data
            setPendingInviteEmail('');
            setPendingInvitePercentage(0);
        } catch (error) {
            console.error('Error sending invite:', error);
            handleError('Failed to send invite. Please try again.');
        }
    };

    // Modified saveShares function to handle invited users
    const saveShares = async () => {
        setSaveText('Please Wait...')
        setBtnDisabled(true)
        try {
            console.log(splits,updateSplit, "splits")
            const map_splits = splits.map(spl => {
                return {
                    user_id: spl.user_id, // This might be null for invited users
                    email: spl.user,
                    recoupment: parseFloat(spl.recoupment) || 0,
                    share: parseFloat(spl.percentage) || 0,
                    isrc: spl.track,
                    title: spl.title,
                    isInvited: spl.isInvited || false,
                    isRecoupmentOnly: spl.isRecoupmentOnly || false
                }
            })
            await createSplit(map_splits, isrc)
            
            // Invalidate relevant queries to refresh data
            await queryClient.invalidateQueries(["all_splits", uid])
            
            // Show success modal
            successBtn.current.click()
            
            // Reset state
            setNewSplits([])
            setSaveText('Save')
            setBtnDisabled(false)
        } catch (error) {
            console.error('An error occurred:', error.message);
            setSaveText("An error occurred")
            setBtnDisabled(false)
        }
    };

    const addRecoup = () => {
        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(recoupEmail)) {
            handleError('Please enter a valid email address for recoupment');
            return;
        }

        if (recoup <= 0) {
            handleError('Recoupment amount must be greater than 0');
            return;
        }

        // Check if this email already has recoupment
        const existingRecoupment = splits.find(split => 
            split.track === isrc && 
            split.user.toLowerCase() === recoupEmail.toLowerCase() &&
            split.recoupment > 0
        );

        if (existingRecoupment) {
            handleError('This email already has recoupment set');
            return;
        }

        // Check if this email exists in splits
        const splitIndex = splits.findIndex(split => 
            split.track === isrc && split.user.toLowerCase() === recoupEmail.toLowerCase()
        );

        if (splitIndex === -1) {
            // Email not found in splits, add it with 0% share but with recoupment
            const newSplit = {
                user_id: null, // We don't know the user ID yet
                user: recoupEmail,
                recoupment: recoup,
                percentage: 0, // 0% share initially
                track: isrc,
                title: title,
                isRecoupmentOnly: true // Flag to indicate this is recoupment-only
            };
            
            setSplits([...splits, newSplit]);
            setNewSplits([...newSplits, newSplit]);
        } else {
            // Update the recoupment for this email
            const updatedSplits = [...splits];
            updatedSplits[splitIndex].recoupment = recoup;
            setSplits(updatedSplits);
            
            // Update in newSplits as well if it exists there
            setNewSplits(prevSplits => 
                prevSplits.map(item => 
                    item.user.toLowerCase() === recoupEmail.toLowerCase() && item.track === isrc 
                        ? { ...item, recoupment: recoup } 
                        : item
                )
            );
        }
        
        // Reset inputs
        setRecoup(0);
        setRecoupEmail('');
    }

    const trackSplits = splits.filter(item => item.track === isrc)
    const totalShares = trackSplits.reduce((acc, product) => acc + product.percentage * 1, 0);


    return (
        <div className='dash-section'>
            <h1 className='dash-title'>Splits</h1>
            <div className="row">
                <div className="col-12 mt-4">
                    <div className="dash-card">
                        <div className="dash-tabs">
                            <Link
                                to={'#'}
                                className={`dash-tab ${tab === 1 && 'active'}`}
                                onClick={() => { setTab(1); setCurrentPage(1) }}
                            >My Splits</Link>
                            <Link
                                to={'#'}
                                className={`dash-tab ${tab === 2 && 'active'}`}
                                onClick={() => { setTab(2); setCurrentPage(1) }}
                            >Add Splits</Link>
                            <Link
                                to={'#'}
                                className={`dash-tab ${tab === 3 && 'active'}`}
                                onClick={() => { setTab(3); setCurrentPage(1) }}
                            >Invited Splits</Link>
                        </div>
                        {
                            tab !== 3 && (
                                <>
                                    {
                                        tab === 2 && (
                                            <input type="text" className='dash-input mb-0 mt-3' onChange={handleSearch} placeholder='Search by title/isrc...' />
                                        )
                                    }
                                    <div className="table-responsive mt-3">
                                        <table className="table dash-table">
                                            <thead>
                                                <tr>
                                                    <td>Title</td>
                                                    <td>ISRC</td>
                                                    <td>Genre</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    currentItems.map((track, i) => (
                                                        <tr key={i}>
                                                            <td>
                                                                <div className="table-item">
                                                                    {track.title}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="table-item">
                                                                    {track.isrc}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="table-item">
                                                                    {track.genre}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="table-item">
                                                                    <Link to={'#'} onClick={() => { 
                                                                        setIsrc(track.isrc); 
                                                                        setTitle(track.title);
                                                                        setEmail(localStorage.getItem('email') || ''); 
                                                                    }} data-bs-toggle="modal" data-bs-target="#addShareModal">
                                                                        <i
                                                                            className="fi fi-rr-eye table-action-btn a-blue"
                                                                        ></i>
                                                                    </Link>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
                                </>
                            )
                        }
                        {
                            tab === 3 && (
                                <InviteSplitsTab inviteSplits={inviteSplits} inviteCurrentItems={inviteCurrentItems} inviteCurrentPage={inviteCurrentPage} inviteTotalPages={inviteTotalPages}/>
                            )
                        }
                    </div>
                </div>
            </div>

            <SplitModal 
                email={email}
                isrc={isrc}
                title={title}
                allUsers={allUsers}
                uid={uid}
                currentItems={allSplits ? allSplits.splits : []}
                onClose={() => {
                    setIsrc('');
                    setTitle('');
                }}
            />

        </div>
    )
}

export default Splits